import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import ButtonSimple from '../../../components/ButtonSimple'
import UserImage from '../../../components/UserImage'
import { getUsernameLabel } from '../../../components/UserLink'
import * as AuctionStatus from '../../../constants/AuctionStatus'
import { getAuctionStatusFromTokenMetadata } from '../../../utils/auction-status'
import { getLinkEntity } from '../../../utils/links'
import { MEDIA_QUERY_DESKTOP } from '../../../utils/media-query'
import { getUserProfileRoute } from '../../../utils/routes'

const Component = styled.div`
  margin-top: 1rem;
`

const PrimaryRow = styled.div`
  width: 100%;
`

const Property = styled.div`
  width: 100%;
`

const MultiProperties = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;

  ${MEDIA_QUERY_DESKTOP} {
    grid-gap: 2rem;
    margin-bottom: 0;
  }
`

const PropertyLabel = styled.div`
  opacity: .5;
  line-height: 1;
  margin-bottom: .75rem;

  ${MEDIA_QUERY_DESKTOP} {
    font-size: 18px;
  }
`

const PropertyValue = styled.div`
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
  display: flex;
  align-content: center;

  ${MEDIA_QUERY_DESKTOP} {
    font-size: 24px;
  }
`

const Controls = styled.div`
  margin-top: 1rem;

  ${MEDIA_QUERY_DESKTOP} {
    margin-top: 3rem;
  }

  button {
    margin-right: 1rem;
  }
`

const UserLink = styled.div`
  line-height: 1;
  display: flex;
  align-content: center;
  justify-content: center;
  margin-left: .5rem;
`

const Anchor = styled.a`
  font-size: 14px;
  line-height: 18px;
  color: white;
  font-weight: 400;
`

const AuctionInfo = ({ tokenMetadata }) => {
  const auctionStatus = getAuctionStatusFromTokenMetadata(tokenMetadata)
  const link = getLinkEntity({
    slug: tokenMetadata.slug,
    creatorUsername: tokenMetadata.creator.username
  })

  if (auctionStatus === AuctionStatus.FRESH) {
    return (
      <Component>
        <PrimaryRow>
          <Property>
            <PropertyLabel>
              Reserve price
            </PropertyLabel>
            <PropertyValue>
              {tokenMetadata.reservePriceInEth} ETH
            </PropertyValue>
          </Property>
        </PrimaryRow>
        <Controls>
          <Link
            href={link}
            passHref
          >
            <a>
              <ButtonSimple variant={ButtonSimple.VARIANT_PRIMARY}>
                View track
              </ButtonSimple>
            </a>
          </Link>
          <Link
            href={link + '/bid'}
            passHref
          >
            <a>
              <ButtonSimple variant={ButtonSimple.VARIANT_PRIMARY_BORDER}>
                Place a bid
              </ButtonSimple>
            </a>
          </Link>
        </Controls>
      </Component>
    )
  } else if (auctionStatus === AuctionStatus.SOLD) {
    const owner = tokenMetadata.owner
    const usernameLabel = getUsernameLabel(owner.username)

    return (
      <Component>
        <PrimaryRow>
          <MultiProperties>
            <Property>
              <PropertyLabel>
                Sold for
              </PropertyLabel>
              <PropertyValue>
                {tokenMetadata.reservePriceInEth} ETH
              </PropertyValue>
            </Property>
            <Property>
              <PropertyLabel>
                Owned by
              </PropertyLabel>
              <PropertyValue>
                <UserImage
                  user={owner}
                  size={22}
                />
                <UserLink>
                  <Link
                    href={getUserProfileRoute({
                      username: owner.username
                    })}
                    passHref
                  >
                    <Anchor>
                      @{usernameLabel}
                    </Anchor>
                  </Link>
                </UserLink>
              </PropertyValue>
            </Property>
          </MultiProperties>
        </PrimaryRow>
        <Controls>
          <Link
            href={link}
            passHref
          >
            <a>
              <ButtonSimple variant={ButtonSimple.VARIANT_PRIMARY}>
                View track
              </ButtonSimple>
            </a>
          </Link>
        </Controls>
      </Component>
    )
  }

  return null
}

export default AuctionInfo
